import apiClient from './client';

/**
 * MED-1389: a booking made through a group booking link that did not attach
 * to a session. It holds the coach's time and sent an invite. Staff only.
 */
export type UnattachedBookingOutcome =
  | 'unknown_email'
  | 'not_in_group'
  | 'already_scheduled'
  | 'no_unscheduled_session';

export interface UnattachedPublicBooking {
  id: string;
  scheduled_start: string;
  duration_minutes: number;
  attach_outcome: UnattachedBookingOutcome;
  /** unconfirmed: a later step failed, so the event may not exist. */
  status: 'scheduled' | 'unconfirmed';
  booker_name: string;
  booker_email: string;
  coach_name: string | null;
  group_id: string;
  group_name: string;
  touchpoint_label: string;
  booked_with: 'calendly' | 'google_calendar';
}

export const cohortPublicBookingsApi = {
  async listUnattached(cohortId: string): Promise<UnattachedPublicBooking[]> {
    return apiClient.get<UnattachedPublicBooking[]>(
      `/api/cohorts/${cohortId}/public-bookings`
    );
  },

  async cancel(
    cohortId: string,
    bookingId: string
  ): Promise<{ id: string; status: 'canceled' }> {
    return apiClient.post<{ id: string; status: 'canceled' }>(
      `/api/cohorts/${cohortId}/public-bookings/${bookingId}/cancel`
    );
  },

  /**
   * Remove a booking from the list without a vendor cancel. The API allows it
   * only when Calendly refuses to show the booking (403 or 404).
   */
  async remove(
    cohortId: string,
    bookingId: string
  ): Promise<{ id: string; status: 'canceled' }> {
    return apiClient.post<{ id: string; status: 'canceled' }>(
      `/api/cohorts/${cohortId}/public-bookings/${bookingId}/remove`
    );
  },
};

export default cohortPublicBookingsApi;
